export function RegMark() {
  return <sup className="reg-mark">&reg;</sup>;
}

export function BosfedName() {
  return <>Bosfed<RegMark /></>;
}

export function BosfedLogoName() {
  return <>BOSFED<RegMark /></>;
}

export function BostonFederalName() {
  return <>Boston Federal<RegMark /></>;
}

export function ScapeSourceName() {
  return <>ScapeSource<RegMark /></>;
}
